import { Component, Input } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-show-ean',
  templateUrl: './show-ean.component.html',
  styleUrls: ['./show-ean.component.scss']
})
export class ShowEanComponent {
  @Input() cartItems: any = [];

  background = 'transparent';
  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 700,
    navText: ['<img src="/assets/img/prev.svg">', '<img src="/assets/img/next.svg">'],
    responsive: {
      0: {
        items: 1
      }
    },
    nav: true
  };

  constructor() {
  }

}
